import {AlertCircle} from 'lucide-react';
import { DISCLAIMER } from "@/lib/site";

function Disclaimer({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-start gap-3 p-4 rounded-xl bg-amber-50 border border-amber-200 ${className}`}>
      <AlertCircle size={18} className="text-amber-600 shrink-0 mt-0.5" />
      <p className="text-xs text-amber-900 leading-relaxed">{DISCLAIMER}</p>
    </div>
  );
}

export default Disclaimer;
